import { render, staticRenderFns } from "./forward.vue?vue&type=template&id=fed7e5ae&scoped=true&"
var script = {}
import style0 from "./forward.vue?vue&type=style&index=0&id=fed7e5ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed7e5ae",
  null
  
)

export default component.exports